var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8 5C8.8 7.09868 7.09868 8.8 5 8.8C4.16718 8.8 3.39693 8.53209 2.77074 8.07774L8.07774 2.77074C8.53209 3.39693 8.8 4.16718 8.8 5ZM1.92222 7.22921L7.22921 1.92222C6.60303 1.4679 5.8328 1.2 5 1.2C2.90132 1.2 1.2 2.90132 1.2 5C1.2 5.8328 1.4679 6.60303 1.92222 7.22921ZM10 5C10 7.76142 7.76142 10 5 10C2.23858 10 0 7.76142 0 5C0 2.23858 2.23858 0 5 0C7.76142 0 10 2.23858 10 5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopIcon);
export default __webpack_public_path__ + "static/media/StopIcon.bd99cee072dec4631ed3ae8995f30e7e.svg";
export { ForwardRef as ReactComponent };